import { renderLastActivity } from 'pages/Workshop/Forms/components/FormsTable';

export const LastActivityColumn = ({ row }) => {
  return renderLastActivity(row);
};
